app = {

	//Trackers

	//INNIT FUNCTIONS
	init: function () {

		//bind events
		app.bindEvents();

		//Page Specifics innits
		//app.formatSize();

		switch (document.body.getAttribute('data-pgType')) {
			case 'client':
				app.projectSearch();
				break;
			case 'heading':
			case 'project':

				break;
			case 'format':
				app.vidEmbed(); // Responsive iframes
				break;
		}
		//app.videoController();
	},

	//EVENT BINDINGS
	bindEvents: function () {

		$('.statusKey a').click(function (e) {
			e.preventDefault();
			app.statusFilter($(this), $(this).data('filterby'));
		});

		$('.format-archive__toggle').click(function (e) {
			e.preventDefault();
			app.toggleArchived($(this));
		});


		/*
				$('#tutorialToggle').click(function(){
					$('#tutorialPanal').toggleClass('is-open is-closed');
				});
		*/

		/*
				$('#camp-sort-grid').click(function(e){
					e.preventDefault();
					app.showAlphabet();
				});


				$('#camp-sort-alpha').click(function(e){
					e.preventDefault();
					app.showAlphabet(true);
				});
		*/

	},

	//FUNCTIONS

	/*
		showAlphabet:function(state) {

			if (state === true) {
	// 			alert('True');
				$('.alpha-divider').fadeIn();
				$('#camp-sort-grid').removeClass('is-active');
				$('#camp-sort-alpha').addClass('is-active');

			} else {
	// 			alert('FALSE');
				$('.alpha-divider').fadeOut();
				$('#camp-sort-alpha').removeClass('is-active');
				$('#camp-sort-grid').addClass('is-active');
			}

		},
	*/

	vidEmbed: function () {

		$('.vid-embed').each(function () {
			$this = $(this);
			$embed = $this.find('iframe');
			width = $embed.attr('width');
			height = $embed.attr('height');
			ratio = height / (width / 100);

			$this.css('max-width', width + 'px')
			$this.find('.ratio__height').css('padding-bottom', ratio + '%');
		})

	},

	// Open and close archived format accordians
	toggleArchived: function (el) {

		var $archive = $(el).closest('.format-archive')

		if (!$archive.hasClass('is-active')) {
			$archive.addClass('is-active');
		} else {
			$archive.removeClass('is-active');
		}
	},




	projectSearch: function () {

		var projectList = new List('projectList', {
			valueNames: ['item-project__name'],
			fuzzySearch: {
				searchClass: "project-searcher",
				location: 0,
				distance: 100,
				threshold: 0.4,
				multiSearch: true
			}
		});

	},

	removeFilter: function () {
		$('.statusKey a').removeClass('is-filteredOut');
		$('.statusKey a').removeClass('is-filteredIn');
		$('.list-tree li').removeClass('is-filteredOut');
		$('.list-tree li').removeClass('is-filteredIn');
	},

	statusFilter: function (thisToggle, filterBy) {


		if ($(thisToggle).is('.is-filteredIn')) {
			app.removeFilter();
		} else {
			app.removeFilter();
			$(thisToggle).addClass('is-filteredIn');

			$('.statusKey a').not(thisToggle).each(function () {
				$(this).addClass('is-filteredOut');
			})

			$('.list-tree li.status').each(function () {

				if ($(this).data('status') !== filterBy) {
					$(this).addClass('is-filteredOut');
				} else {
					$(this).addClass('is-filteredIn');
				}



			});

			//Check the SH that need filtering

			//Check the SH that need filtering
			$('li.subHeading').each(function () {

				$(this).has('ul li.is-filteredIn').addClass('is-filteredIn');
				$(this).not('ul li.is-filteredIn').addClass('is-filteredOut')

			})

			$('li.mainHeading').each(function () {

				$(this).has('ul li.is-filteredIn').addClass('is-filteredIn');
				$(this).not('ul li.is-filteredIn').addClass('is-filteredOut')

			})

			/*
						$('li.subHeading').each(function(){



							if ($(this).has('li.is-filteredIn')) {
								$(this).addClass('is-filteredIn')
							} else {
								$(this).addClass('is-filteredOut')
							}
						})
			*/

			/*
						$('li.mainHeading').each(function(){

							if ($(this).has('ul li.is-filteredIn')) {
								$(this).addClass('is-filteredIn')
							} else {
								$(this).addClass('is-filteredOut')
							}
						})
			*/

		}
	},

}; //END app();

//DOC READY
jQuery(document).ready(function () {
	app.init();
});